import { forwardRef } from 'react';
import { formatBrazilianDocument } from './document-format.js';
import { MaskedInput, type MaskedInputProps } from './masked-input.js';

export interface DocumentInputProps extends Omit<MaskedInputProps, 'format' | 'label'> {
  /// CPF para pessoa, CNPJ para empresa. O rótulo e a máscara seguem.
  kind: 'CPF' | 'CNPJ';
  label?: string | undefined;
}

/// CPF ou CNPJ com a máscara do tipo. Só formata: conferir os dígitos verificadores é da regra de
/// quem usa, que sabe dizer "CPF inválido" na hora certa.
export const DocumentInput = forwardRef<HTMLInputElement, DocumentInputProps>(
  ({ kind, label, ...props }, ref) => (
    <MaskedInput
      ref={ref}
      label={label ?? kind}
      inputMode="numeric"
      placeholder={kind === 'CPF' ? '000.000.000-00' : '00.000.000/0000-00'}
      format={(digits) => formatBrazilianDocument(digits, kind)}
      {...props}
    />
  ),
);
DocumentInput.displayName = 'DocumentInput';
